export default {
      id: "volume-usage",
      viewBox: "0 0 16 16",
      url: "assets/" + "sprite.svg#volume-usage",
      toString: function () {
        return this.url;
      }
    }